<template>
  <v-card flat class="px-3">
    <v-col cols="12" class="body-bold-smaller py-0">
      <a type="primary" size="xsmall" @click="handleBack">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>

    <v-col class="pt-1 py-0">
      <span class="body-bold-medium"
        >{{ $t('message.pages.drm.watermark') }} (Watermark)
      </span>
    </v-col>

    <v-col cols="12" class="py-0">
      <span class="body-regular-smaller textType6--text pageDescription">
        {{ $t('message.pages.drm.protectYourVideos') }}
        <a target="_blank" type="secondary" :href="drmArticle">
          <span>
            {{ $t('message.embedModal.knowMore') }}
          </span>
          <v-icon size="12">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>

    <v-col class="pt-6 py-0">
      <span ref="topElement" class="body-bold-medium"
        >{{ $t('message.pages.drm.selectGroup') }}
      </span>
    </v-col>
    <v-card-text
      v-if="!drmGroupsLoading"
      class="overflow-y-auto ma-0 pa-0"
      flat
      width="100%"
    >
      <v-row v-if="drmGroups.length" no-gutters>
        <v-col v-if="drmGroups.length > 1" cols="12">
          <v-card
            v-for="(group, i) in drmGroups"
            class="d-flex flex-row align-center"
            :key="i"
            flat
            :class="{ 'cursor-default': alreadyDrm }"
            height="47"
            width="100%"
            :disabled="!hasEditVideoPerm"
            @click="handleActiveGroup(group)"
            ><v-tooltip bottom :disabled="!alreadyDrm">
              <template v-slot:activator="{ on, attrs }">
                <v-row no-gutters v-bind="attrs" v-on="on">
                  <v-card
                    class="d-flex align-center justify-center mr-1"
                    flat
                    color="background"
                  >
                    <v-btn
                      :disabled="alreadyDrm"
                      icon
                      @click="handleActiveGroup(group)"
                    >
                      <v-card
                        class="d-flex align-center justify-center elevation-0 rounded-pill"
                        width="20px"
                        height="20px"
                        :class="{
                          'neutral-95-lightest': alreadyDrm && group.isActive,
                        }"
                        :color="
                          group.isActive
                            ? '#3F55EE'
                            : $vuetify.theme.dark
                            ? '#000000'
                            : '#FFFFFF'
                        "
                        :style="
                          group.isActive
                            ? ''
                            : $vuetify.theme.dark
                            ? 'border: 2px solid #52577A'
                            : 'border: 2px solid #D0D1D9'
                        "
                      >
                        <v-card
                          v-if="group.isActive"
                          :class="{
                            'neutral-80-lighter': alreadyDrm && group.isActive,
                          }"
                          :color="
                            group.isActive
                              ? '#FFFFFF'
                              : !$vuetify.theme.dark
                              ? '#000000'
                              : '#FFFFFF'
                          "
                          width="10px"
                          height="10px"
                          flat
                          class="rounded-pill"
                        />
                      </v-card>
                    </v-btn>
                  </v-card>
                  <v-col class="d-flex align-center justify-start">
                    <span
                      :title="group.name"
                      class="text-truncate"
                      :style="`max-width: ${nameSizing}px`"
                    >
                      {{
                        group.name === 'Default'
                          ? locale === 'es'
                            ? 'Predeterminado'
                            : locale === 'en'
                            ? 'Default'
                            : 'Padrão'
                          : group.name
                      }}</span
                    >
                  </v-col>
                  <v-card
                    v-if="!group.value"
                    class="d-flex align-center justify-end mr-3"
                    flat
                    color="background"
                    width="125px"
                  >
                    <v-tag type="default">
                      {{
                        group.webhook_source_name
                          ? group.webhook_source_name.charAt(0).toUpperCase() +
                            group.webhook_source_name.slice(1)
                          : 'API'
                      }}</v-tag
                    >
                  </v-card>
                </v-row>
              </template>
              <span>{{
                $t('message.pages.drmModalDashboard.tooltipAlreadyDrm')
              }}</span>
            </v-tooltip>
          </v-card>
        </v-col>
        <v-col v-else class="pl-3" cols="12">
          <p class="textType6--text body-regular-smaller">
            {{ $t('message.pages.drm.noGroupsInAccount') }}
          </p>
          <base-btn @click="goToDrmPage" type="secondary" size="small" :disabled="!hasEditVideoPerm">
            {{ $t('message.pages.drm.createYourGroup') }}
            <v-icon size="20">mdi-open-in-new</v-icon>
          </base-btn>
        </v-col>
      </v-row>
      <v-row v-else no-gutters>
        <v-col cols="12">
          <span>
            {{ $t('message.pages.drm.updateGroup.text1') }}
          </span>
        </v-col>
        <v-col cols="12" class="my-6">
          <span>
            <b>{{ $t('message.pages.drm.updateGroup.text2') }}</b>
          </span>
        </v-col>
        <v-col cols="12">
          <v-btn color="primary" @click="handleActiveDrm">
            <v-icon>mdi-cog</v-icon
            >{{ $t('message.pages.drm.updateGroup.activeDRM') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else style="height: 350px">
      <v-row no-gutters align="center" justify="center">
        <loading-logo :value="200" />
      </v-row>
    </v-card-text>
    <v-col>
      <base-btn
        v-if="drmGroups.length > 1"
        @click="goToDrmPage"
        type="secondary"
        size="small"
      >
        {{ $t('message.pages.drm.createYourGroup') }}
        <v-icon size="20">mdi-open-in-new</v-icon>
      </base-btn>
    </v-col>
    <portal to="actions-footer">
      <ActionModal
        :showAction1="true"
        :showAction2="true"
        :disableTooltip1="checkIfHasChanged || isFetching"
        :disableTooltip2="checkIfHasChanged || isFetching"
        :disabledAction1="!checkIfHasChanged"
        :disabledAction2="isFetching || drmGroupsLoading || !checkIfHasChanged"
        :handleAction1="discardChanges"
        :handleAction2="handleConfirm"
        :loadingAction2="isFetching"
      />
    </portal>
  </v-card>
</template>

<script>
import drmApi from '@/services/drmApi'
import LoadingLogo from '@/components/LoadingLogo.vue'
import ActionModal from '@/components/ActionModal.vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import i18n from '@/translations/lang'

export default {
  name: 'DrmGroupUpdateList',
  components: {
    LoadingLogo,
    ActionModal,
  },
  data: () => ({
    open: false,
    isFetching: false,
    cardHeight: 0,
    drmGroupsLoading: false,
    initialActiveGroupId: null,
    drmGroups: [],
    startValueDrmGroups: [],
    db: null,
    isDrmActive: true,
    initialActiveItem: null,
    alreadyDrm: false,
  }),
  props: {
    selectedItem: Object,
    handleBack: {
      type: Function,
      required: true,
    },
    hasEdit: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    ...mapGetters('user', ['hasEditVideoPerm']),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    drmArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/what-is-drm-watermark-and-how-does-it-work-1tirjk3'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/que-es-y-como-funciona-nuestro-drm-marca-de-agua-12eaco2/'
      }
      return 'https://help.pandavideo.com/pt-br/article/o-que-e-e-como-funciona-o-nosso-drm-watermark-1tnesei/'
    },
    nameSizing() {
      let width = window.innerWidth
      if (this.isMobileBreakpoint) {
        return '135'
      }
      if (width > 1600) {
        return '400'
      } else if (width > 1250) {
        return '220'
      } else {
        return '150'
      }
    },
    checkIfHasChanged() {
      const currentActiveGroupId = this.drmGroups.find(
        (group) => group.isActive
      )?.id
      return currentActiveGroupId !== this.initialActiveGroupId
    },
  },
  async created() {
    this.$root.$on('changeLanguage', this.updateText)
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    await this.getDrmGroups()
    this.setInfo()
    this.initialActiveGroupId = this.drmGroups.find(
      (group) => group.isActive
    )?.id
    this.open = true
  },
  updated() {
    if (this.hasEdit)
      this.hasEdit[0] =
        this.isFetching || this.drmGroupsLoading || this.checkIfHasChanged
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['editFolder']),
    async handleActiveDrm() {
      this.drmGroupsLoading = true
      try {
        await drmApi.activateDrm()
        this.getDrmGroups()
      } catch (e) {
        console.log('e', e)
      }
    },
    discardChanges() {
      this.drmGroups.forEach((group) => {
        group.isActive = group.id === this.initialActiveGroupId
      })
      this.isFetching = false
    },
    updateText() {
      const noneGroup = this.drmGroups.find((group) => group.value === 'none')
      if (noneGroup) {
        noneGroup.name = this.$i18next.t('message.pages.drmModalDashboard.none')
      }
    },
    goToDrmPage() {
      this.$router.push({ name: 'DRM' })
    },
    async getDrmGroups() {
      this.isDrmActive = true
      this.drmGroupsLoading = true
      try {
        let ret = await drmApi.getDrmGroups()
        this.startValueDrmGroups = ret.data
        this.drmGroups = ret.data
      } catch (error) {
        this.drmGroupsLoading = false
        if (error.response.data.errMsg.includes('Drm is not active')) {
          this.isDrmActive = false
          return
        }
        setTimeout(() => {
          this.getDrmGroups()
        }, 2000)
      }
      this.drmGroupsLoading = false
    },
    handleActiveGroup(activateGroup) {
      if (activateGroup.isActive || this.alreadyDrm) return

      this.drmGroups = this.drmGroups.map((group) => ({
        ...group,
        isActive: group.id === activateGroup.id,
      }))
    },
    setInfo() {
      if (this.selectedItem.drm_group_ids) {
        let fixedGroups = this.drmGroups.map((group) => {
          let foundGroup = this.selectedItem.drm_group_ids.find(
            (el) => el.drm_group_id === group.id
          )
          return { ...group, isActive: !!foundGroup }
        })
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      } else {
        let fixedGroups = this.drmGroups.map((group) => ({
          ...group,
          isActive: false,
        }))
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      }
      this.drmGroups.push({
        name: this.$i18next.t('message.pages.drmModalDashboard.none'),
        value: 'none',
        isActive: !this.selectedItem.drm_group_ids,
      })
      this.initialActiveItem = this.drmGroups.find((item) => item.isActive)
      let parent_folderId = localStorage.getItem('folderFather')
      if (!parent_folderId) parent_folderId = this.video.folder_id
      if (parent_folderId && this.$route.params.id) {
        const drms_groups = this.drmGroups.flatMap((row) => row.folder_ids)
        this.alreadyDrm = drms_groups.some((row) => row == parent_folderId)
      }
    },
    async handleConfirm() {
      this.isFetching = true
      await this.getNewGroups()

      this.startValueDrmGroups = JSON.parse(JSON.stringify(this.drmGroups))
      this.initialActiveGroupId = this.drmGroups.find(
        (group) => group.isActive
      )?.id

      this.handleSnackbar(this.$t('message.pages.video.changesSaved'))
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async removeFromAllGroups() {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      let removingIds = this.selectedItem.drm_group_ids.map(
        (item) => item.drm_group_id
      )
      for (let removingId of removingIds) {
        try {
          await drmApi.drmUpdateVideos(removingId, modifiedData)
          this.selectedItem.drm_group_ids =
            this.selectedItem.drm_group_ids.filter(
              (item) => item.drm_group_id != removingId
            )
          if (!this.selectedItem.drm_group_ids.length)
            delete this.selectedItem['drm_group_ids']
        } catch (e) {
          console.log('e', e)
        }
      }
      this.updateInPage()
      this.isFetching = false
    },
    getNewGroups() {
      let noGroup = this.drmGroups.find((group) => group.value === 'none')
      if (noGroup.isActive) {
        if (this.initialActiveItem?.value === 'none') {
          return
        }
        this.removeFromAllGroups()
        return
      }
      let startActiveArray = this.startValueDrmGroups.map(
        (group) => group.isActive
      )
      let newActiveArray = this.drmGroups.map((group) => group.isActive)
      let arrayIndexes = []
      for (let i = 0; i < startActiveArray.length; i++) {
        if (startActiveArray[i] !== newActiveArray[i]) {
          let indexedValue = i
          arrayIndexes.push(indexedValue)
        }
      }
      this.getGroupChanges(arrayIndexes)
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    async getGroupChanges(indexes) {
      let toBeAddedGroups = []
      let toBeRemovedGroups = []
      for (let index of indexes) {
        let changedGroup = this.drmGroups[index]
        if (this.selectedItem.drm_group_ids) {
          let findGroup = this.selectedItem.drm_group_ids.find(
            (group) => group.drm_group_id === changedGroup.id
          )
          if (findGroup) {
            toBeRemovedGroups.push(changedGroup)
          } else {
            toBeAddedGroups.push(changedGroup)
          }
        } else {
          toBeAddedGroups.push(changedGroup)
        }
      }
      for (let group of toBeRemovedGroups) {
        await this.removeItemFromGroup(group)
      }
      for (let group of toBeAddedGroups) {
        await this.addItemFromGroup(group)
      }
      this.updateInPage()
      if (!this.selectedItem.name) {
        this.isFetching = false
      }
    },
    async addItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'increment',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'increment',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        let newObj = {
          active: group.active,
          drm_group_id: group.id,
        }
        if (this.selectedItem.drm_group_ids) {
          this.selectedItem.drm_group_ids.push(newObj)
        } else {
          this.selectedItem.drm_group_ids = [newObj]
        }
      } catch (e) {
        console.log('e', e)
      }
    },
    async removeItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        this.selectedItem.drm_group_ids =
          this.selectedItem.drm_group_ids.filter(
            (item) => item.drm_group_id != group.id
          )
      } catch (e) {
        console.log('e', e)
      }
    },
    updateInPage() {
      if (this.selectedItem.name) {
        this.updateFolderDrmGroups(this.selectedItem)
        this.$root.$emit('updateFolderVideosPage', this.selectedItem)
      } else {
        if (this.$route.params.id) {
          this.updateIndexedVideo(this.selectedItem)
        } else {
          this.$root.$emit('updateVideoVideosPage', this.selectedItem)
        }
      }
    },
    async updateIndexedVideo(video) {
      await window.db.videos.update(video.id, video)
    },
    updateFolderDrmGroups(folder) {
      this.editFolder(folder)
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style scoped lang="scss">
.backIcon {
  color: varFigma(brand-60-base) !important;
}
.group-card {
  cursor: pointer;
}
.group-card:hover {
  background-color: var(--v-primary-lighten3);
}
::v-deep .v-card--link:focus:before {
  opacity: 0 !important;
}
.backBtn {
  cursor: pointer;
}
.cursor-default {
  cursor: default !important;
}
</style>
